import { useContext } from "react";

import { Mode } from "models/Mode";
import { TableStatus, TableState } from "models/Table";

import { ReservationsContext } from "../Reservations";


interface UseMapReturn {
    onReservationClick: (id: string) => void,
    onTableClick: (tableState: TableState) => void,
}

export function useMap(): UseMapReturn {
    const {
        reservationsControl: {
            isFormDirty,
            mode,
            onExitFormWarningChange,
            onModeChange,
            onReservationIdChange,
            onTablesStateChange,
            tablesState,
        },
    } = useContext(ReservationsContext);

    function onTableClick({ reservations, status, tableNum }: TableState): void {
        switch (mode) {
            case Mode.DAILY_MESSAGE_EDIT:
            case Mode.RESERVATION_BROWSING:
            case Mode.RESERVATION_PREVIEW:
                switch (status) {
                    case TableStatus.BOOKED:
                        if (!isFormDirty) {
                            onTablesStateChange(tablesState?.map(tableState => ({ ...tableState, status: tableState.status === TableStatus.SELECTED ? tableState.reservations.length ? TableStatus.BOOKED : TableStatus.AVAILABLE : tableState.status })) ?? []);
                            onReservationIdChange({ id: reservations[0].id, shouldRefetch: true });
                            onModeChange(Mode.RESERVATION_PREVIEW);
                        } else {
                            onExitFormWarningChange({ modeToBeSet: Mode.RESERVATION_PREVIEW, reservationId: reservations[0].id, show: true });
                        }
                        break;

                    case TableStatus.AVAILABLE:
                        if (!isFormDirty) {
                            onTablesStateChange(tablesState?.map(tableState => ({ ...tableState, status: tableState.tableNum === tableNum ? TableStatus.SELECTED : tableState.reservations.length ? TableStatus.BOOKED : TableStatus.AVAILABLE })) ?? []);
                            onModeChange(Mode.RESERVATION_CREATION);
                        } else {
                            onExitFormWarningChange({ modeToBeSet: Mode.RESERVATION_CREATION, show: true, tableState: { reservations, status, tableNum } });
                        }
                        break;
                }
                break;

            case Mode.RESERVATION_CREATION:
            case Mode.RESERVATION_EDIT:
                switch (status) {
                    case TableStatus.BOOKED:
                        break;

                    case TableStatus.AVAILABLE:
                        onTablesStateChange([ { status: TableStatus.SELECTED, tableNum } ]);
                        break;

                    case TableStatus.SELECTED:
                        onTablesStateChange([ { status: TableStatus.AVAILABLE, tableNum } ]);
                        break;
                }
                break;

            default:
                break;
        }
    }

    function onReservationClick(id: string): void {
        switch (mode) {
            case Mode.DAILY_MESSAGE_EDIT:
            case Mode.RESERVATION_BROWSING:
            case Mode.RESERVATION_PREVIEW:
                if (!isFormDirty) {
                    onReservationIdChange({ id, shouldRefetch: true });
                    onModeChange(Mode.RESERVATION_PREVIEW);
                } else {
                    onExitFormWarningChange({ modeToBeSet: Mode.RESERVATION_PREVIEW, reservationId: id, show: true });
                }
                break;

            default:
                break;
        }
    }

    return { onReservationClick, onTableClick };
}